import { render, staticRenderFns } from "./SupportPackages.vue?vue&type=template&id=e8b94966"
import script from "./SupportPackages.vue?vue&type=script&lang=js"
export * from "./SupportPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports